<template>
  <div class="text-center">
    <quantity-of-transfers-per-day-chart
      v-show="!showBlankslate"
      :date-range="dateRange"
      :on-load="onLoad"
      :height="'170vh'"
    />
    <img
      v-show="showBlankslate"
      :src="'/assets/img/blankslate/blankslate-column-chart.svg'"
    >
  </div>
</template>

<script>
import QuantityOfTransfersPerDayChart from '@/apps/payments/payments/indicator/components/presentational/QuantityOfTransfersPerDayChart';

export default {
  name: 'quantity-of-transfers-per-day-chart-container',
  components: {
    QuantityOfTransfersPerDayChart
  },
  props: {
    dateRange: {
      required: true
    }
  },
  data: () => ({
    showBlankslate: false
  }),
  watch: {
    dateRange: {
      deep: true,
      handler() {
        this.showBlankslate = false;
      }
    }
  },
  methods: {
    onLoad(data) {
      const sumQuantity = data.reduce((acc, i) => (acc += i.quantity), 0);
      if (!sumQuantity) {
        this.showBlankslate = true;
      }
    }
  }
};
</script>
